import React from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '../../../store/actions/index';
import { LOGIN_PATH } from '../../../shared/utility';

// Staff's way off the customer home page. "/" lands everyone here, employees
// included, so there has to be a way through to the HRMS login — at the top of
// the page and again in the footer, which is why this is its own component
// rather than markup in either one.
//
// It signs the browser out on the way, and it does so thoroughly, because nobody
// should reach a staff page from here without typing a username and password:
//
//   - logout() clears localStorage, so the token, EmpId and the stored
//     `defaultpage` all go. Every visitor to the special order page is signed in
//     as the '9999' guest account (see SpecialOrderDetails.componentDidMount), and
//     a staff member could be carrying a real session too.
//   - A plain <a>, not a react-router <Link>: this is a full page load, so the
//     redux store is built from scratch as well. A client-side link would leave
//     the signed-out store holding the previous session's authentication response
//     in memory, which is exactly the kind of leftover the login screens have to
//     be able to trust (see IS_SIGNED_IN).
//
// The click handler runs before the browser navigates, so the session is gone
// before the login page is requested.

const EmployeeLoginLink = ({ className, label = 'Employee login' }) => {
    const dispatch = useDispatch();

    return (
        <a
            className={className}
            href={LOGIN_PATH}
            onClick={() => dispatch(actions.logout())}
        >
            <i className="pi pi-sign-in" />
            <span>{label}</span>
        </a>
    );
};

export default EmployeeLoginLink;
